import { IStepProps, IStepsProps } from '@amobee/component-library';
import { CurrencyPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { isEqual } from 'lodash';
import * as moment from 'moment-timezone';
import { GenderConst } from 'src/app/application/campaigns/campaign-edit/constants/Gender.const';
import { CampaingStatusSteps } from 'src/app/data/constants/campaign-status-steps';
import { CampaignStatus as DashboardStatus } from 'src/app/data/constants/campaign-status.const';
import { Constants } from 'src/app/data/constants/constants.enum';
import { GoalType } from 'src/app/data/constants/goal-type.const';
import { MediaPlanStatus } from 'src/app/data/constants/mediaplan-status.const';
import { ListResponse } from 'src/app/data/interfaces/ListResponse';
import { AvailableFlightDateRangeVO } from 'src/app/data/vo/AvailableFlightDateRangeVO';
import { CampaignVO } from 'src/app/data/vo/CampaignVO';
import { CreativeVO } from 'src/app/data/vo/CreativeVO';
import { MediaPlanOptionVO, MediaPlanType } from 'src/app/data/vo/MediaPlanOptionVO';
import { MediaPlanVO } from 'src/app/data/vo/MediaPlanVO';
import { NameValuePairVO } from 'src/app/data/vo/NameValuePairVO';
import { PrebuiltCampaignVO } from 'src/app/data/vo/PrebuiltCampaignVO';
import { PricingSummaryVO } from 'src/app/data/vo/PricingSummaryVO';
import { SegmentVO } from 'src/app/data/vo/SegmentVO';
import { AdProduceService } from 'src/app/services/ad-produce.service';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { BaseAdapter } from 'src/whiteLabel/mediaCorps/adapters/base-adapter';
import { api } from 'src/whiteLabel/mediaCorps/services/campaign/campaign-api.service';
import {
    AttributeHierarchyFilter,
    AttributesInput,
    AttributeType,
    AudienceSizeInput,
    BaseParams,
    CampaignAttributeConstraint,
    CampaignAttributeCriteria,
    CampaignAttributeValue,
    CampaignBudgetUpdateInput,
    CampaignCreationData,
    CampaignCreationInput,
    CampaignDashboardInput,
    CampaignFlightCreationInput,
    CampaignFlightData,
    CampaignGoalConstraint,
    CampaignGoalConstraintInput,
    CampaignIdParam,
    CampaignMediaPlanData,
    CampaignNameUpdateInput,
    CampaignObjectiveCreationInput,
    CampaignObjectiveUpdateInput,
    CampaignPricingSummary,
    CampaignSegmentInput,
    CampaignSettingsData,
    CampaignStatusUpdateInput,
    CustomFilter,
    MediaPlanOptionsInput,
    MediaPlanStatusInput,
    MediaPlanStatusResponse,
    PacingReportData,
    PlanCreationInput,
    PlanCreationData,
    PrebuiltCampaignData,
    CampaignOrder
} from 'src/whiteLabel/mediaCorps/services/campaign/campaign-data';
import { api as creativeApi } from 'src/whiteLabel/mediaCorps/services/creative/creative-api.service';
import {
    CampaignAssociations,
    CampaignCreativeData,
    CampaignCreativeStatus,
    CreativeStatus
} from 'src/whiteLabel/mediaCorps/services/creative/creative-data';
import { CreativeAdapter } from './creative-adapter';
import { ModalService } from 'src/app/services/modal.service';
import { OrderVO } from 'src/app/data/vo/OrderVO';
import { OrderStatus } from 'src/app/data/constants/orderStatus.enum';
import { PaymentAdjustmentType } from 'src/app/data/constants/payment-adjustment-type.enum';
//we will use name to differentiate attributes and daypart constraints
const CONSTRAINT_LCG_ATTRIBUTES = 'Language/Channel/Genre Allocation Rule';
const CONSTRAINT_CHANNEL_EXCLUSION = 'Channel Exclusion Rule';
const CONSTRAINT_DAYPART = 'Campaign Daypart Allocation rule';
const CONSTRAINT_AD_DURATION = 'Ad Length Rule';
const MAXIMIZE_BUY_DEMO_IMPRESSIONS_OBJECTIVE_ID = 54;
const MAXIMIZE_BUY_DEMO_REACH_OBJECTIVE_ID = 55;
const CURRENCY = new CurrencyPipe('en-US');
@Injectable()
export class CampaignAdapter extends BaseAdapter {
    constructor(
        private http: HttpClient,
        private storageService: StorageService,
        private creativeAdapter: CreativeAdapter,
        private adProduceService: AdProduceService,
        protected modal: ModalService) {
        super(http, storageService, modal);
    }

    /**
     * accepted parameters from UI:
     * {
     *     offset: number,
     *     limit: number,
     *     searchString: string
     * }
     * */
    public getCampaignListData(params: any, overwrittenCBA?: { customerId?: number, brandId?: number, advertiserId?: number }): Promise<ListResponse> {
        return this.getCBAId().then((cba) => {
            let input = new CampaignDashboardInput(cba);

            if (overwrittenCBA) {
                input.customer_id = overwrittenCBA.customerId;
                input.advertiser_id = overwrittenCBA.advertiserId;
                input.brand_id = overwrittenCBA.brandId;
            }

            if (params.offset && params.offset > 0) {
                input.offset = params.offset;
            }
            if (params.limit && params.limit > 0) {
                input.limit = params.limit;
            }
            if (params.searchString && params.searchString.length > 0) {
                input.search = params.searchString;
            }
            let custom_filters = [];
            if (params.campaignStatus && params.campaignStatus.length > 0 && DashboardStatus[params.campaignStatus]) {
                let dashboardStatus = DashboardStatus[params.campaignStatus];
                const campaignStatusFilter: CustomFilter = {
                    field: "campaign_status",
                    operation: "in",
                    values: dashboardStatus.apiStatus
                };
                custom_filters.push(campaignStatusFilter);
                if (dashboardStatus == DashboardStatus.Running || dashboardStatus == DashboardStatus.Ready) {
                    let current: Date = new Date();
                    let currentMinusOneMS: Date = new Date(current.getTime() - 1);   // current time -1 millisecond
                    const startDateFilter: CustomFilter = {
                        field: "start_date",
                        operation: dashboardStatus == DashboardStatus.Ready ? "gte" : "lte",
                        values: [dashboardStatus == DashboardStatus.Ready ? current.toJSON() : currentMinusOneMS.toJSON()]
                    };
                    custom_filters.push(startDateFilter);
                }
            }
            input.custom_filters = custom_filters;

            if (params.columnKey) {
                switch (params.columnKey) {
                    case 'id':
                        input.order_by = 'campaign_id';
                        break;
                    case 'name':
                        input.order_by = 'campaign_name';
                        break;
                    case 'status':
                        input.order_by = 'campaign_status';
                        break;
                    case 'startDate':
                        input.order_by = 'start_date';
                        break;
                    case 'endDate':
                        input.order_by = 'end_date';
                        break;
                    case 'budget':
                        input.order_by = 'budget';
                        break;
                    default:
                        input.order_by = 'campaign_id';
                        break;
                }
                input.order = params.sortOrder ? params.sortOrder.toUpperCase() : 'DESC';
            }

            return api.getCampaignDashboard(this.http, input)
                .then((result) => {
                    let results = result.data.map((value) => {
                        return {
                            name: value.campaign_name,
                            status: this.convertCampaignStatus(value.campaign_status, value.start_date ? moment.utc(value.start_date.utc).toDate() : null),
                            id: value.campaign_id,
                            startDate: value.start_date.utc ? moment.utc(value.start_date.utc).toDate() : null,
                            endDate: value.end_date.utc ? moment.utc(value.end_date.utc).toDate() : null,
                            budget: CURRENCY.transform(value.budget, environment.currencySymbol),
                            bonus: value.additional_discount ? 'Yes' : 'No'
                        };
                    });
                    let count = result.count;
                    console.log(results, count);
                    return { results: results, count: count };
                });
        }).then();
    }

    private convertCampaignStatus(campaignStatus: string, startDate?: Date): string {
        const today: Date = new Date();

        let dashboardStatus: string;

        switch (campaignStatus.toUpperCase()) {
            case 'CANCELLED':
            case 'ENDED':
            case 'FINISHED':
                dashboardStatus = DashboardStatus.Completed.key;
                break;
            case 'DECLINED':
                dashboardStatus = DashboardStatus.Canceled.key;
                break;
            case 'NEGOTIATING':
            case 'REQUEST SENT':
            case 'SENT':
                dashboardStatus = DashboardStatus.Pending.key;
                break;
            case 'NEW REQUEST':
            case 'PLANNING':
                dashboardStatus = DashboardStatus.Draft.key;
                break;
            case 'RUNNING':
                (startDate && startDate.getTime() < today.getTime()) ?
                    dashboardStatus = DashboardStatus.Running.key : dashboardStatus = DashboardStatus.Ready.key;
                break;
            default:
                dashboardStatus = DashboardStatus.Draft.key;
                break;

        }
        return dashboardStatus;
    }

    public createPlanAndCampaign(): Promise<CampaignVO> {
        return this.getCBAId().then((cba) => {
            let planInput = new PlanCreationInput(cba);
            planInput.name = 'Plan_' + new Date().getTime();
            return api.createPlan(this.http, planInput).then((plan) => {
                let campaignInput = new CampaignCreationInput();
                campaignInput.name = 'Campaign_' + new Date().getTime();
                campaignInput.plan_id = plan.plan_id;
                return api.createCampaign(this.http, campaignInput).then((resp: CampaignCreationData) => {
                    let cvo = this.convertCampaign(resp);
                    cvo.status = DashboardStatus.Draft.key;
                    return cvo;
                });
            }).then();
        }).then();
    }

    public updateCampaignName(cvo: CampaignVO): Promise<CampaignVO> {
        let input = new CampaignNameUpdateInput();
        input.name = cvo.name;
        input.campaign_id = cvo.id;
        return api.updateCampaignName(this.http, input).then((resp: CampaignCreationData) => {
            return this.convertCampaign(resp);
        });
    }

    public deleteCampaign(campaignId: number): Promise<any> {
        return api.deleteCampaign(this.http, campaignId).then((resp: any) => {
            return resp;
        })
    }

    public getCampaignData(campaignId: number): Promise<CampaignVO> {
        return api.getCampaignData(this.http, campaignId).then((resp) => {
            return this.convertCampaign(resp);
        });
    }

    public getPrebuiltCampaignData(campaignId: number): Promise<Array<PrebuiltCampaignVO>> {
        const key = 'getPrebuiltCampaignData()-' + campaignId;
        const cachedResponse = this.storageService.getItem(key, 'session');

        if (cachedResponse) {
            return Promise.resolve(cachedResponse);
        } else {
            return api.getPrebuiltCampaignData(this.http, campaignId).then((resp) => {
                let result: Array<PrebuiltCampaignVO> = this.convertPrebuiltCampaignData(resp);
                this.storageService.setItem(key, result, 'session');
                return result;
            });
        }
    }

    public getAvailableFlightDateRange(campaignId: number, useCache: boolean = true): Promise<AvailableFlightDateRangeVO> {
        const key = 'getAvailableFlightDateRange()-' + campaignId;
        const cachedResponse = this.storageService.getItem(key, 'session');

        if (cachedResponse && useCache) {
            //cache is storing it as string
            cachedResponse.minStartDate = new Date(cachedResponse.minStartDate);
            cachedResponse.maxEndDate = new Date(cachedResponse.maxEndDate);
            return Promise.resolve(cachedResponse);
        } else {
            return api.getAvails(this.http, campaignId).then((resp) => {
                let minDate: Date, maxDate: Date, temp: Date;
                if (resp && resp.length) {
                    for (let avail of resp) {
                        if (avail.start_at) {
                            temp = new Date(avail.start_at);
                            if (!minDate || minDate.getTime() > temp.getTime()) {
                                minDate = temp;
                            }
                            if (!maxDate || maxDate.getTime() < temp.getTime()) {
                                maxDate = temp;
                            }
                        }
                    }
                }
                let result = {
                    minStartDate: minDate,
                    //add 7 days to reach end of inventory week
                    maxEndDate: new Date(maxDate.getTime() + 86400 * 7000)
                }
                this.storageService.setItem(key, result, 'session');
                return result;
            });
        }
    }

    public createCampaignFlight(startDate: Date, endDate: Date, campaignId: number): Promise<any> {
        let input = new CampaignFlightCreationInput();
        input.campaign_id = campaignId;
        input.start_date = startDate.toJSON();
        input.end_date = endDate.toJSON();
        return api.createCampaignFlight(this.http, input).then();
    }

    public updateCampaignFlight(startDate: Date, endDate: Date, flightId: number): Promise<any> {
        let input = new CampaignFlightData();
        input.flight_id = flightId;
        input.start_date = startDate.toJSON();
        input.end_date = endDate.toJSON();

        return api.updateCampaignFlight(this.http, input).then();
    }

    private convertCampaign(data: CampaignCreationData): CampaignVO {
        let cvo = new CampaignVO();
        cvo.id = data.campaign_id;
        cvo.name = data.name;
        cvo.status = data.status;
        cvo.planId = data.plan_id;
        return cvo;
    }

    public convertPrebuiltCampaignData(data: Array<PrebuiltCampaignData>): Array<PrebuiltCampaignVO> {
        let results: Array<PrebuiltCampaignVO> = [];
        for (let pcd of data) {
            let pcvo = new PrebuiltCampaignVO();
            pcvo.id = pcd.template_id;
            pcvo.name = pcd.name;
            pcvo.description = pcd.description;
            let cvo = new CampaignVO();
            // get age gender
            if (pcd.content && pcd.content.audience && pcd.content.audience.values) {
                for (let demoValue of pcd.content.audience.values) {
                    if (demoValue.values && demoValue.values.length > 0) {
                        if (demoValue.type == 'GENDER') {
                            if (demoValue.values.length == 1) {
                                cvo.gender = demoValue.values[0].id;
                            } else {
                                //assuming can only have F and M if more than 1
                                cvo.gender = GenderConst.All.value;
                            }
                        }
                        if (demoValue.type == 'AGE') {
                            cvo.age = this.convertDemoAgeId(demoValue.values[0].id);
                        }
                    }
                }
            }
            // get segments
            if (pcd.content && pcd.content.audience_id) {
                let segment = new NameValuePairVO();
                segment.value = pcd.content.audience_id.toString();
                segment.name = pcd.name;
                cvo.segment = segment;
            }

            // get channels
            let channels = [];
            if (pcd.content && pcd.content.channels && pcd.content.channels.criteria && pcd.content.channels.criteria.values) {
                for (let value of pcd.content.channels.criteria.values) {
                    if (value.type === 'NETWORK') {
                        for (let v of value.values) {
                            channels.push(v.id);
                        }
                    }
                }
            }
            cvo.channels = channels;
            // set goalType
            if (pcd.content && pcd.content.objective && pcd.content.objective.type_id) {
                if (pcd.content.objective.type_id === MAXIMIZE_BUY_DEMO_IMPRESSIONS_OBJECTIVE_ID) {
                    cvo.goalType = GoalType.moreImpressionsGRPs.value;
                } else if (pcd.content.objective.type_id === MAXIMIZE_BUY_DEMO_REACH_OBJECTIVE_ID) {
                    cvo.goalType = GoalType.moreReach.value;
                }
            }
            pcvo.cvo = cvo;
            pcvo.description = pcd.description;
            results.push(pcvo);
        }
        return results;
    }

    public getSegments(campaignId: number): Promise<SegmentVO[]> {
        let params = new CampaignIdParam(campaignId);
        return api.getSegments(this.http, params).then((resp) => {
            return resp.map(data => {
                let segment = new SegmentVO();
                segment.value = data.expression_id.toString();
                segment.name = data.name;
                segment.description = data.description;
                if (data.strategic_demo && data.strategic_demo.length) {
                    //sample: [{strategic_demo_gender: "A", strategic_demo_min_age: 15, strategic_demo_max_age: 34}]
                    let sd = data.strategic_demo[0];
                    segment.gender = sd.strategic_demo_gender || segment.gender;
                    if (sd.strategic_demo_min_age) {
                        if (sd.strategic_demo_max_age) {
                            segment.age = sd.strategic_demo_min_age + '-' + sd.strategic_demo_max_age;
                        } else {
                            segment.age = sd.strategic_demo_min_age + '+';
                        }
                    }
                }
                return segment;
            });
        });
    }

    public getChannels(startDate?: number, endDate?: number, languages?: Array<string>) {
        return this.getAttributes(AttributeType.Channel, startDate, endDate, languages);
    }

    public getLanguages(startDate?: number, endDate?: number) {
        return this.getAttributes(AttributeType.Language, startDate, endDate);
    }

    public getGenre(startDate?: number, endDate?: number, languages?: Array<string>, channels?: Array<string>) {
        return this.getAttributes(AttributeType.Genre, startDate, endDate, languages, channels);
    }

    private getAttributes(type: string, startDate?: number, endDate?: number, languages?: Array<string>, channels?: Array<string>): Promise<NameValuePairVO[]> {
        const key = this.getAttributesSessionKey(type, startDate, endDate, languages, channels);
        const cachedResponse = this.storageService.getItem(key, 'session');

        if (cachedResponse) {
            return Promise.resolve(cachedResponse);
        } else {
            if (languages && languages.length === 0 || channels && channels.length == 0) {
                let result: NameValuePairVO[] = [];
                this.storageService.setItem(key, result, 'session');
                return Promise.resolve([]);
            }
            let input = new AttributesInput();
            input.attribute_type = type;
            if (startDate && endDate) {
                let start = new Date(startDate);
                let end = new Date(endDate);
                input.additional_filters = 'IncludeOnlyPlacementsWithAvails:true;StartDate:' + start.toLocaleDateString('en-US') + ';EndDate:' + end.toLocaleDateString('en-US');
            }
            if (languages || channels) {
                input.attribute_hierarchy_filters = [];
            }
            if (languages) {
                let languageFilter = new AttributeHierarchyFilter();
                languageFilter.attribute_type = 'Language';
                languageFilter.exclude = false;
                languageFilter.ids = languages;
                input.attribute_hierarchy_filters.push(languageFilter);
            }
            if (channels) {
                let channelFilter = new AttributeHierarchyFilter();
                channelFilter.attribute_type = 'Network';
                channelFilter.exclude = false;
                channelFilter.ids = channels;
                input.attribute_hierarchy_filters.push(channelFilter);
            }
            let params = new BaseParams();
            params.order = 'ASC';
            params.order_by = 'name';
            params.offset = 0;
            params.limit = 100;
            return api.getAttributes(this.http, input, params).then((resp) => {
                let result: NameValuePairVO[] = resp.map((value) => {
                    let nvp = new NameValuePairVO();
                    nvp.name = value.description || value.name;
                    nvp.value = value.id;
                    return nvp;
                });
                this.storageService.setItem(key, result, 'session');
                return result;
            });
        }
    }

    private getAttributesSessionKey(type: string, startDate?: number, endDate?: number, languages?: Array<string>, channels?: Array<string>) {
        let key = `getAttributes()-${type}?`;
        if (startDate && endDate) {
            key += `startDate=${startDate}&endDate=${endDate}&`;
        }
        if (languages) {
            key += `languages=${languages.sort().join(',')}&`;
        }

        if (channels) {
            key += `channels=${channels.sort().join(',')}`;
        }
        return key;
    }

    /**
     * Returns available age options for each gender
     * sample: {
     *     A: ['4+', '5-13', '14-21'],
     *     M: ['14-21'],
     *     F: ['4+']
     * }
     * */
    public getGenderAgeMapping(): Promise<any> {
        const key = 'getGenderAgeMapping()';
        const cachedResponse = this.storageService.getItem(key, 'session');
        if (cachedResponse) {
            return Promise.resolve(cachedResponse);
        } else {
            return api.getDemoOptions(this.http).then((resp) => {
                let genderAgeMap = {
                    'A': [],
                    'M': [],
                    'F': []
                };
                for (let demo of resp) {
                    let age = demo.id.slice(0, 1);
                    let gender = demo.id.slice(1);
                    genderAgeMap[age].push(gender);
                }
                this.storageService.setItem(key, genderAgeMap, 'session');
                return genderAgeMap;
            });
        }
    }

    private convertDemoAgeValue(id: string) {
        //4-13 -> [4,13]
        //4+ -> [4,]
        if (id && id.length > 0) {
            if (id.indexOf('-') !== -1) {
                let rangeAge = id.split('-');
                return '[' + rangeAge[0] + ',' + rangeAge[1] + ']';
            } else if (id.indexOf('+') !== -1) {
                let minAge = id.slice(0, id.indexOf('+'));
                return '[' + minAge + ',]';
            }
        }
        return null;
    }

    private convertDemoAgeId(value: string) {
        //[4,13] -> 4-13
        //[35,] -> 35+
        if (value && value.length > 0) {
            let valuePairs = value.slice(1, value.length - 1).split(',');
            if (valuePairs[0] && valuePairs[0].length > 0) {
                if (valuePairs[1]) {
                    if (valuePairs[1].length > 0) {
                        return valuePairs[0] + '-' + valuePairs[1];
                    } else {
                        return valuePairs[0] + '+';
                    }
                } else {
                    return valuePairs[0] + '+';
                }
            }
        }
        return null;
    }

    private setDaypartConstraint(campaignId: number, mediaPlanOption: MediaPlanOptionVO, min: number, max: number): Promise<any> {
        let cac = new CampaignAttributeConstraint();
        cac.constraint_type_id = 'demand-group-control';
        cac.name = CONSTRAINT_DAYPART;
        cac.rank = 6;
        cac.min_value = min;
        cac.max_value = max;
        cac.violated = false;
        cac.basis = { 'metric_id': 'budget-percent', 'criteria': null };
        let criteria = new CampaignAttributeCriteria();
        criteria.negative = false;
        criteria.type = 'AND';
        criteria.values = [];
        let daypart = new CampaignAttributeValue();
        daypart.type = 'DAYPART';
        daypart.values = [];
        daypart.values.push({ 'id': '315_PT' });
        criteria.values.push(daypart);
        cac.criteria = criteria;
        if (mediaPlanOption.dayPartConstraintId) {
            cac.constraint_id = mediaPlanOption.dayPartConstraintId;
            return api.updateCampaignAttributes(this.http, cac, campaignId).then();
        } else {
            return api.saveCampaignAttributes(this.http, cac, campaignId).then((resp) => {
                mediaPlanOption.dayPartConstraintId = resp.constraint_id;
                return resp;
            });
        }
    }
    //
    // private removeDaypartConstraint(campaignId: number, constraintId: string): Promise<any> {
    //     return api.deleteCampaignAttributes(this.http, campaignId, constraintId);
    // }

    private addDurationConstraints(campaignId: number, creatives: CreativeVO[], adDuration: string): Promise<Array<CampaignAttributeConstraint>> {
        if (creatives && !_.isEmpty(creatives) || !_.isEmpty(adDuration)) {
            let durationMap = {};
            if (!_.isEmpty(creatives) && _.size(creatives) > 0) {
                creatives.forEach((c: CreativeVO) => {
                    if (!durationMap[c.adDuration]) {
                        durationMap[c.adDuration] = true;
                    }
                });
            } else if (!_.isEmpty(adDuration)) {
                durationMap[adDuration] = true;
            }
            // split module val evenly to the first (moduleVal-th) items
            let moduleVal = 100 % Object.keys(durationMap).length;
            // the rest will be set to split val
            let splitVal = Math.floor(100 / Object.keys(durationMap).length) / 100;
            let input: CampaignAttributeConstraint[] = Object.keys(durationMap).map((duration: string, index: number) => {
                let adConstraint = new CampaignAttributeConstraint();
                let percentValue = (index + 1 <= moduleVal) ? splitVal + 0.01 : splitVal;
                adConstraint.constraint_type_id = 'ad-duration';
                adConstraint.metric_id = 'spend-percent';
                adConstraint.name = CONSTRAINT_AD_DURATION;
                adConstraint.min_value = percentValue;
                adConstraint.max_value = percentValue;
                adConstraint.criteria = {
                    type: 'AND',
                    values: [
                        {
                            negative: false,
                            type: 'AD_DURATION',
                            values: [{ id: duration }]
                        }
                    ]
                };
                return adConstraint;
            });
            return api.updateAdDurationConstraints(this.http, campaignId, input);
        } else {
            return api.updateAdDurationConstraints(this.http, campaignId, []);
        }
    }

    public getTotalAudienceSize(campaignId: number): Promise<any> {
        const key = 'getTotalAudienceSize()';
        const cachedResponse = this.storageService.getItem(key, 'session');
        if (cachedResponse) {
            return Promise.resolve(cachedResponse);
        } else {
            const audienceCriteriaKey = 'getTotalAudienceCriteria()';
            const audienceCriteriaCachedResponse = this.storageService.getItem(audienceCriteriaKey, 'session');
            let getTotalAudienceCriteriaPromise: Promise<any>;
            if (audienceCriteriaCachedResponse) {
                getTotalAudienceCriteriaPromise = Promise.resolve(audienceCriteriaCachedResponse);
            } else {
                getTotalAudienceCriteriaPromise = api.getTotalAudienceCriteria(this.http, campaignId);
            }
            return getTotalAudienceCriteriaPromise.then((resp) => {
                if (!audienceCriteriaCachedResponse) {
                    this.storageService.setItem(key, resp, 'session');
                }
                let audienceSizeInput = new AudienceSizeInput();

                let totalTargetingCriteria = new CampaignAttributeCriteria();
                totalTargetingCriteria.type = resp.expression_value.type;
                totalTargetingCriteria.values = resp.expression_value.values;
                audienceSizeInput.total_targeting_criteria = totalTargetingCriteria;

                let targetingCriteria = new CampaignAttributeCriteria();
                targetingCriteria.type = 'AND';

                let genderValue = new CampaignAttributeValue();
                genderValue.type = 'GENDER';
                genderValue.values = [{ id: 'M' }, { id: 'F' }];

                targetingCriteria.values = [genderValue];
                audienceSizeInput.targeting_criteria = targetingCriteria;
                return api.getAudienceSize(this.http, audienceSizeInput).then((resp) => {
                    this.storageService.setItem(key, resp.total_audience_size, 'session');
                    return resp.total_audience_size;
                });
            });
        }
    }

    public getTargetedAudienceSize(campaignId: number, segment: NameValuePairVO,
        gender: string = GenderConst.All.value, age: string): Promise<any> {
        const key = 'getTotalAudienceCriteria()';
        const cachedResponse = this.storageService.getItem(key, 'session');
        let getTotalAudienceCriteriaPromise: Promise<any>;
        if (cachedResponse) {
            getTotalAudienceCriteriaPromise = Promise.resolve(cachedResponse);
        } else {
            getTotalAudienceCriteriaPromise = api.getTotalAudienceCriteria(this.http, campaignId);
        }
        return getTotalAudienceCriteriaPromise.then((resp) => {
            if (!cachedResponse) {
                this.storageService.setItem(key, resp, 'session');
            }
            let audienceSizeInput = new AudienceSizeInput();

            let totalTargetingCriteria = new CampaignAttributeCriteria();
            totalTargetingCriteria.type = resp.expression_value.type;
            totalTargetingCriteria.values = resp.expression_value.values;
            audienceSizeInput.total_targeting_criteria = totalTargetingCriteria;

            let targetingCriteria = new CampaignAttributeCriteria();
            targetingCriteria.type = 'AND';

            let genderValue = new CampaignAttributeValue();
            genderValue.type = 'GENDER';
            if (gender === GenderConst.All.value) {
                genderValue.values = [{ id: 'M' }, { id: 'F' }];
            } else {
                genderValue.values = [{ id: gender }];
            }
            targetingCriteria.values = [genderValue];


            let ageValue = new CampaignAttributeValue();
            if (age) {
                let convertedAge = this.convertDemoAgeValue(age.trim());
                ageValue.type = 'AGE';
                ageValue.values = [{ id: convertedAge }];
                targetingCriteria.values.push(ageValue);
            }

            let audExpPromise = Promise.resolve();
            if (segment) {
                audExpPromise = api.getAudienceExpressions(this.http, segment.value).then((resp) => {
                    if (resp.expression_value && resp.expression_value.values) {
                        let behaviors = resp.expression_value.values.filter(v => v.type === 'BEHAVIORAL');
                        if (behaviors.length) {
                            targetingCriteria.values.push(behaviors[0]);
                        }
                        // else {
                        //     let behavioralValue = new CampaignAttributeValue();
                        //     behavioralValue.type = 'BEHAVIORAL';
                        //     behavioralValue.values = [];
                        //     targetingCriteria.values.push(behavioralValue);
                        // }
                    }
                });
            }

            audienceSizeInput.targeting_criteria = targetingCriteria;

            return audExpPromise.then(() => api.getAudienceSize(this.http, audienceSizeInput).then((resp) => {
                return resp.targeted_audience_size;
            }));
        });
    }

    public getMediaPlanOptions(cvo: CampaignVO): Promise<MediaPlanOptionVO[]> {
        let mediaPlanOptionsInput = new MediaPlanOptionsInput();
        mediaPlanOptionsInput.budget = cvo.budget || 0;
        mediaPlanOptionsInput.channel = cvo.channels;
        mediaPlanOptionsInput.genre = cvo.genres;
        mediaPlanOptionsInput.goal = cvo.goalObjectiveId ? cvo.goalObjectiveId.toString() : '';
        mediaPlanOptionsInput.campaign_start_date = new Date(cvo.startDate).toJSON();
        mediaPlanOptionsInput.campaign_end_date = new Date(cvo.endDate).toJSON();
        return api.getMediaPlanOptions(this.http, cvo.id, mediaPlanOptionsInput).then((resp) => {
            return resp.map(v => {
                let r = new MediaPlanOptionVO();
                r.type = MediaPlanType[v.description.trim()];
                r.cpm = +v.cpm.toFixed(2);
                r.impressions = v.impressions;
                r.estimatedSpots = v.estimated_spots;
                return r;
            });
        });
    }

    public processMediaPlanOption(cvo: CampaignVO, oldMediaPlanOptionVO?: MediaPlanOptionVO): Promise<any> {
        if (cvo && cvo.mediaPlanOption && cvo.mediaPlanOption.cpm && cvo.mediaPlanOption.type) {
            let updateMPO: boolean = this.updateNeeded(cvo.mediaPlanOption, oldMediaPlanOptionVO, ['type', 'cpm']);
            console.log('updateMPO', updateMPO);
            if (!updateMPO) {
                return Promise.resolve();
            }
            let pt_min = -1, pt_max = -1;
            switch (cvo.mediaPlanOption.type) {
                case MediaPlanType.Standard:
                    pt_min = 0;
                    pt_max = 0.5;
                    break;
                case MediaPlanType.Plus:
                    pt_min = 0.25;
                    pt_max = 0.5;
                    break;
                case MediaPlanType.Premium:
                    pt_min = 0.51;
                    pt_max = 1;
                    break;
                default:
                    return;
            }

            //create or update daypart
            let ptPromise = Promise.resolve();
            if (pt_min !== -1 && pt_max !== -1) {
                ptPromise = this.setDaypartConstraint(cvo.id, cvo.mediaPlanOption, pt_min, pt_max);
            }
            //create or update buy demo
            if (cvo.mediaPlanOption.buyDemoConstraintId) {
                let update = new CampaignGoalConstraint();
                update.id = cvo.mediaPlanOption.buyDemoConstraintId;
                update.goal = cvo.mediaPlanOption.cpm;
                return ptPromise.then(() => api.updateCampaignGoalConstraint(this.http, cvo.id, update));
            } else {
                let input = new CampaignGoalConstraintInput();
                input.goal = cvo.mediaPlanOption.cpm;
                return ptPromise.then(() => api.createCampaignGoalConstraint(this.http, cvo.id, input).then((resp) => {
                    cvo.mediaPlanOption.buyDemoConstraintId = resp.id;
                }));
            }
        } else {
            return Promise.reject('Cannot Process Invalid Media Plan Option');
        }
    }

    public fetchMediaPlanOption(campaignId: number): Promise<MediaPlanOptionVO> {
        return api.getCampaignGoalConstraints(this.http, campaignId).then((resp) => {
            if (resp && resp.length > 0) {
                const buyDemo = resp[0];
                return api.getCampaignAttributes(this.http, campaignId).then((resp) => {
                    let mpOption: MediaPlanOptionVO;
                    if (resp && resp.length) {
                        let dayparts = resp.filter(v => v.name == CONSTRAINT_DAYPART);
                        if (dayparts.length > 0) {
                            let daypart = dayparts[0];
                            mpOption = new MediaPlanOptionVO();
                            mpOption.buyDemoConstraintId = buyDemo.id;
                            mpOption.cpm = buyDemo.goal;
                            mpOption.dayPartConstraintId = daypart.constraint_id;
                            switch (daypart.min_value) {
                                case 0:
                                    mpOption.type = MediaPlanType.Standard;
                                    break;
                                case 0.25:
                                    mpOption.type = MediaPlanType.Plus;
                                    break;
                                case 0.51:
                                    mpOption.type = MediaPlanType.Premium;
                                    break;
                                default:
                                    mpOption.type = MediaPlanType.Standard;
                            }
                        }
                    }
                    return mpOption;
                });
            }
        }).then();
    }

    public fullSaveAllCampaignData(cvo: CampaignVO): Promise<any> {
        let referenceKeyFields = ['flightId', 'constraintId', 'excludeChannelsConstraintId', 'goalObjectiveId'];
        console.log('Full saving campaign');
        return this.fetchAllCampaignData(cvo.id).then((apiCvo: CampaignVO) => {
            // remove all possible reference fields from UI VO, this is new object reference so original cvo is unchanged.
            let cvoWithoutReferences = _.omit(cvo, referenceKeyFields);
            // reassign all UI changes to api VO, excluding reference fields
            _.assign(apiCvo, cvoWithoutReferences);

            //passing null as oldCvo will trigger full save
            return this.saveAllCampaignData(apiCvo, null).then(() => {
                // upon succeed, reassign all updated fields to original cvo.
                _.assign(cvo, apiCvo);
            });
        });
    }

    private updateNeeded(cvo: any, oldCvo: any = null, fields: Array<string>): boolean {
        let res = true;
        if (oldCvo && fields && fields.length) {
            res = false;
            fields.forEach(v => {
                if (cvo[v] && oldCvo[v]) {
                    res = res || !isEqual(cvo[v], oldCvo[v]);
                } else {
                    res = true;
                }
            });
        }
        return res;
    }
    /**
     * This one is used to camppaing and campaign related data such as
     * Name, Flight, Audience, Demographic, Channel, Language, Creative, etc
     *
     * The optional oldVO is used to be compared with the newVO to determine certain actions such as
     * Create vs Update flight since they use different APIs
     * */
    public saveAllCampaignData(cvo: CampaignVO, oldCvo?: CampaignVO): Promise<any> {
        //exactly the same, no save needed
        if (oldCvo && isEqual(cvo, oldCvo)) {
            console.log('Nothing to save for campaign')
            return Promise.resolve();
        }

        //update flight if already exists
        let updateCampaignName = this.updateNeeded(cvo, oldCvo, ['name']),
            updateFlight = this.updateNeeded(cvo, oldCvo, ['startDate', 'endDate', 'flightId']),
            updateSegment = this.updateNeeded(cvo, oldCvo, ['segment']),
            updateDemo = this.updateNeeded(cvo, oldCvo, ['gender', 'age']),
            updateLCG = this.updateNeeded(cvo, oldCvo, ['languages', 'channels', 'genres', 'constraintId']),
            updateBudget = this.updateNeeded(cvo, oldCvo, ['budget']),
            updateGoal = this.updateNeeded(cvo, oldCvo, ['goalType', 'autoSelect', 'goalObjectiveId']),
            //updateAd = this.updateNeeded(cvo, oldCvo, ['creatives']),
            //there is no way to tell whether a previous creative call failed. so always save for now
            updateAd = true,
            updateMPO = this.updateNeeded(cvo, oldCvo, ['mediaPlanOption']);

        console.log('updateCampaignName', updateCampaignName);
        console.log('updateFlight', updateFlight);
        console.log('updateSegment', updateSegment);
        console.log('updateDemo', updateDemo);
        console.log('updateLCG', updateLCG);
        console.log('updateBudget', updateBudget);
        console.log('updateGoal', updateGoal);
        console.log('updateAd', updateAd);
        console.log('updateMPO', updateMPO);

        let allSavePromises: Array<Promise<any>> = [];
        let campaignUpdatePromise: Promise<CampaignVO> = updateCampaignName ? this.updateCampaignName(cvo) : Promise.resolve(cvo);
        allSavePromises.push(campaignUpdatePromise);

        console.log('updating flight');
        let campaignGoalObjectivePromise: Promise<any> = Promise.resolve();
        let campaignFlightPromise: Promise<any> = Promise.resolve();
        if (updateFlight) {
            if (cvo.flightId && cvo.flightId > 0) {
                campaignFlightPromise = campaignUpdatePromise.then(() => {
                    return this.updateCampaignFlight(new Date(cvo.startDate), new Date(cvo.endDate), cvo.flightId);
                }).then();
                allSavePromises.push(campaignFlightPromise);
            } else {
                campaignFlightPromise = campaignUpdatePromise.then(() => {
                    return this.createCampaignFlight(new Date(cvo.startDate), new Date(cvo.endDate), cvo.id).then((resp) => {
                        cvo.flightId = resp.flight_id;
                        return resp;
                    });
                }).then();
                allSavePromises.push(campaignFlightPromise);
            }
        }

        //update segment
        if (updateSegment) {
            //need to delete old segment
            if (cvo.segment && cvo.segment.value) {
                let campaignSegmentInput = new CampaignSegmentInput();
                campaignSegmentInput.campaign_id = cvo.id;
                campaignSegmentInput.expression_id = Number.parseInt(cvo.segment.value.trim());
                allSavePromises.push(api.updateCampaignSegment(this.http, campaignSegmentInput));
            } else {
                //need to delete segment
                allSavePromises.push(api.deleteCampaignSegment(this.http, cvo.id));
            }
        }
        //update age and gender
        // if (updateDemo) {
        //     if (cvo.gender && cvo.age) {
        //         let age = this.convertDemoAgeValue(cvo.age.trim());
        //         if (age) {
        //             let input = new CampaignAttributeCriteria();
        //             input.type = 'AND';
        //
        //             let ageValue = new CampaignAttributeValue();
        //             ageValue.type = 'AGE';
        //             ageValue.values = [{ id: age }];
        //
        //             let genderValue = new CampaignAttributeValue();
        //             genderValue.type = 'GENDER';
        //             //save campaign gender does not accept 'A' at the moment
        //             if (cvo.gender === GenderConst.All.value) {
        //                 genderValue.values = [{ id: 'M' }, { id: 'F' }];
        //             } else {
        //                 genderValue.values = [{ id: cvo.gender }];
        //             }
        //
        //             input.values = [ageValue, genderValue];
        //             allSavePromises.push(api.saveCampaignDemo(this.http, input, cvo.id));
        //         }
        //     }
        // }
        if (!oldCvo || (!oldCvo.age && !oldCvo.gender)) { //we really just need to call this once for the campaign since it won't ever change
            //Temporary solution, always set buy demo to A15+
            let ageValue = new CampaignAttributeValue();
            ageValue.type = 'AGE';
            ageValue.values = [{ id: '[15,]' }];
            let genderValue = new CampaignAttributeValue();
            genderValue.type = 'GENDER';
            genderValue.values = [{ id: 'M' }, { id: 'F' }];
            let input = new CampaignAttributeCriteria();
            input.type = 'AND';
            input.values = [ageValue, genderValue];
            allSavePromises.push(api.saveCampaignDemo(this.http, input, cvo.id));
        }

        //update budget
        if (updateBudget) {
            if (cvo.budget) {
                let campaignBudgetUpdateInput = new CampaignBudgetUpdateInput();
                campaignBudgetUpdateInput.campaign_id = cvo.id;
                campaignBudgetUpdateInput.spend = cvo.budget;
                allSavePromises.push(api.updateCampaignBudget(this.http, campaignBudgetUpdateInput));
            }
        }

        //TODO: Remove this once auto select logic is finalized and available
        if (updateGoal) {
            if (cvo.autoSelect) {
                cvo.goalType = GoalType.moreImpressionsGRPs.value;
                cvo.autoSelect = false;
            }

            //update goal
            if (cvo.autoSelect) { //this is not reachable. will delete after finalize requirement
                if (cvo.goalObjectiveId) {
                    campaignGoalObjectivePromise = campaignFlightPromise.then(() => {
                        return api.deleteCampaignObjective(this.http, cvo.id, cvo.goalObjectiveId).then((resp) => {
                            cvo.goalType = null;
                            cvo.goalObjectiveId = null;
                            return resp;
                        });
                    }).then();
                    allSavePromises.push(campaignGoalObjectivePromise);
                }
            } else {
                if (cvo.goalObjectiveId && cvo.goalObjectiveId !== null) {
                    let campaignObjectiveUpdateInput = new CampaignObjectiveUpdateInput();
                    campaignObjectiveUpdateInput.campaign_id = cvo.id;
                    campaignObjectiveUpdateInput.campaign_objective_id = cvo.goalObjectiveId;

                    if (cvo.goalType === GoalType.moreImpressionsGRPs.value) {
                        campaignObjectiveUpdateInput.type_id = MAXIMIZE_BUY_DEMO_IMPRESSIONS_OBJECTIVE_ID;
                    } else if (cvo.goalType === GoalType.moreReach.value) {
                        campaignObjectiveUpdateInput.type_id = MAXIMIZE_BUY_DEMO_REACH_OBJECTIVE_ID;
                    }
                    campaignGoalObjectivePromise = campaignFlightPromise.then(() => {
                        return api.updateCampaignObjective(this.http, campaignObjectiveUpdateInput);
                    }).then();
                    allSavePromises.push(campaignGoalObjectivePromise);
                } else {
                    let campaignObjectiveCreationInput = new CampaignObjectiveCreationInput();
                    campaignObjectiveCreationInput.campaign_id = cvo.id;
                    if (cvo.goalType === GoalType.moreImpressionsGRPs.value) {
                        campaignObjectiveCreationInput.type_id = MAXIMIZE_BUY_DEMO_IMPRESSIONS_OBJECTIVE_ID;
                    } else if (cvo.goalType === GoalType.moreReach.value) {
                        campaignObjectiveCreationInput.type_id = MAXIMIZE_BUY_DEMO_REACH_OBJECTIVE_ID;
                    }
                    campaignGoalObjectivePromise = campaignFlightPromise.then(() => {
                        return api.createCampaignObjective(this.http, campaignObjectiveCreationInput).then((resp) => {
                            cvo.goalObjectiveId = resp.id;
                            return resp;
                        });
                    }).then();
                    allSavePromises.push(campaignGoalObjectivePromise);
                }
            }
        } else {
            // if there is no need to update goal, we set campaignGoalObjectivePromise to campaignFlightPromise so that constraints api can wait after
            campaignGoalObjectivePromise = campaignFlightPromise;
        }

        if (updateLCG) {
            //first delete existing constraints, put campaignGoalObjectivePromise in promise so that it will always wait until it finishes
            let deleteLCGPromises: Array<Promise<any>> = [campaignGoalObjectivePromise];
            if (cvo.constraintId) {
                deleteLCGPromises.push(campaignGoalObjectivePromise.then(() => {
                    return api.deleteCampaignAttributes(this.http, cvo.id, cvo.constraintId).then(() => {
                        cvo.constraintId = null;
                    });
                }).then());
            }
            if (cvo.excludeChannelsConstraintId) {
                deleteLCGPromises.push(campaignGoalObjectivePromise.then(() => {
                    return api.deleteCampaignAttributes(this.http, cvo.id, cvo.excludeChannelsConstraintId).then(() => {
                        cvo.excludeChannelsConstraintId = null;
                    });
                }).then());
            }

            //update genres, languages, and channels
            if ((cvo.genres && cvo.genres.length) ||
                (cvo.languages && cvo.languages.length) || (cvo.channels && cvo.channels.length)) {

                //first update channel exclusion constraint
                if (cvo.excludeChannels && cvo.excludeChannels.length) {
                    let eccac = new CampaignAttributeConstraint();
                    eccac.constraint_type_id = 'demand-group-control';
                    eccac.name = CONSTRAINT_CHANNEL_EXCLUSION
                    eccac.rank = 6;
                    eccac.min_value = 0;
                    eccac.max_value = 1;
                    eccac.violated = false;
                    eccac.is_enabled = true;
                    eccac.basis = null;
                    let criteria = new CampaignAttributeCriteria();
                    criteria.negative = true;
                    criteria.type = 'AND';
                    criteria.values = [];
                    let channels = new CampaignAttributeValue();
                    channels.type = 'NETWORK';
                    channels.values = [];
                    for (let channel of cvo.excludeChannels) {
                        channels.values.push({ id: channel });
                    }
                    criteria.values.push(channels);
                    eccac.criteria = criteria;

                    allSavePromises.push(Promise.all(deleteLCGPromises).then(() => {
                        return api.saveCampaignAttributes(this.http, eccac, cvo.id).then((resp) => {
                            cvo.excludeChannelsConstraintId = resp.constraint_id;
                        });
                    }).then());
                }
                //second update normal include constraint
                let cac = new CampaignAttributeConstraint();
                cac.constraint_type_id = 'demand-group-control';
                cac.name = CONSTRAINT_LCG_ATTRIBUTES;
                cac.rank = 6;
                cac.min_value = 1;
                cac.max_value = 1;
                cac.violated = false;
                cac.basis = { 'metric_id': 'budget-percent', 'criteria': null };
                let criteria = new CampaignAttributeCriteria();
                criteria.negative = false;
                criteria.type = 'AND';
                criteria.values = [];
                if (cvo.genres && cvo.genres.length > 0) {
                    let genres = new CampaignAttributeValue();
                    genres.type = 'GENRE';
                    genres.values = [];
                    for (let genre of cvo.genres) {
                        genres.values.push({ id: genre });
                    }
                    criteria.values.push(genres);
                }
                if (cvo.languages && cvo.languages.length > 0) {
                    let languages = new CampaignAttributeValue();
                    languages.type = 'LANGUAGE';
                    languages.values = [];
                    for (let language of cvo.languages) {
                        languages.values.push({ id: language });
                    }
                    criteria.values.push(languages);
                }
                if (cvo.channels && cvo.channels.length > 0) {
                    let channels = new CampaignAttributeValue();
                    channels.type = 'NETWORK';
                    channels.values = [];
                    for (let channel of cvo.channels) {
                        channels.values.push({ id: channel });
                    }
                    criteria.values.push(channels);
                }
                cac.criteria = criteria;


                allSavePromises.push(Promise.all(deleteLCGPromises).then(() => {
                    return api.saveCampaignAttributes(this.http, cac, cvo.id).then((resp) => {
                        cvo.constraintId = resp.constraint_id;
                    })
                }).then());

            }
        }

        //update creative, we will need to wait flight to be created / updated first before saving creatives
        if (updateAd) {
            //skip creative
            allSavePromises.push(this.updateCampaignSettings(cvo.id, cvo.skipCreative));
            let creativeAssignPromise: Promise<any>;
            if (cvo.produceCreative && cvo.produceCreative.length && !cvo.skipCreative) {
                creativeAssignPromise = this.creativeAdapter.createCreative(cvo.produceCreative).then((res: CreativeVO[]) => {
                    let creativesToAssign: CampaignAssociations[] = [];
                    if (_.size(res)) {
                        creativesToAssign = _.map([...cvo.creatives, ...res], (c: CreativeVO) => {
                            return { creative_id: c.creativeId };
                        });
                    }
                    return campaignFlightPromise.then(() => {
                        return creativeApi.assignCreativesToCampaign(this.http, cvo.id, creativesToAssign).then(() => {
                            console.log("creative assigned successfully");
                            cvo.creatives.push(...res);
                            cvo.produceCreative = [];
                            this.adProduceService.updateProduceCreative(cvo.produceCreative);
                        });
                    }).then();
                }).then();
            } else {
                // creative campaign association
                creativeAssignPromise = campaignFlightPromise.then(() => {
                    let creativesToAssign: CampaignAssociations[] = [];
                    if (cvo.creatives && cvo.creatives.length > 0 && !cvo.skipCreative) {
                        creativesToAssign = _.map(cvo.creatives, (c: CreativeVO) => {
                            return { creative_id: c.creativeId };
                        });
                    }
                    return creativeApi.assignCreativesToCampaign(this.http, cvo.id, creativesToAssign);
                }).then();
            }
            if (creativeAssignPromise) {
                allSavePromises.push(creativeAssignPromise);
                // ad duration constraints
                allSavePromises.push(Promise.all([campaignGoalObjectivePromise, creativeAssignPromise]).then(() => {
                    return this.addDurationConstraints(cvo.id, cvo.creatives, cvo.adDuration);
                }).then());
            }
        }

        //update media plan options - we won't process it as of the cvo. only process it independently
        // if (cvo.mediaPlanOption) {
        //     allSavePromises.push(this.processMediaPlanOption(cvo));
        // }

        return Promise.all(allSavePromises).then(() => console.log('After save:', cvo));
    }

    public fetchAllCampaignData(campaignId: number): Promise<CampaignVO> {
        let cvo = new CampaignVO();
        let allFetchPromises: Array<Promise<any>> = [];

        allFetchPromises.push(this.getCampaignData(campaignId).then((resp) => {
            cvo = { ...cvo, ...resp };
        }));
        allFetchPromises.push((api.getCampaignFlight(this.http, campaignId).then((resp) => {
            cvo.startDate = resp && new Date(resp.start_date).getTime();
            cvo.endDate = resp && new Date(resp.end_date).getTime();
            cvo.flightId = resp && resp.flight_id;
        })));
        //get campaign segment
        allFetchPromises.push(api.getCampaignSegment(this.http, { campaign_id: campaignId }).then((resp) => {
            if (resp != null) {
                let campaignSegment = new NameValuePairVO();
                campaignSegment.value = resp.expression_id.toString();
                campaignSegment.name = resp.name;
                cvo.segment = campaignSegment;
                //parse expression_value for the strategic demo setting
                //temporary solution for CSYS-5551
                for (let demoValue of resp.expression_value.values) {
                    if (demoValue.values && demoValue.values.length > 0) {
                        if (demoValue.type == 'GENDER') {
                            if (demoValue.values.length == 1) {
                                cvo.gender = demoValue.values[0].id;
                            } else {
                                //assuming can only have F and M if more than 1
                                cvo.gender = GenderConst.All.value;
                            }
                        }
                        if (demoValue.type == 'AGE') {
                            cvo.age = this.convertDemoAgeId(demoValue.values[0].id);
                        }
                    }
                }
                //end of temporary solution
            }
        }));

        //temporarily disabled for CSYS-5551
        //get age gender
        /*
        allFetchPromises.push(api.getCampaignDemo(this.http, campaignId).then((resp) => {
            for (let demoValue of resp.values) {
                if (demoValue.values && demoValue.values.length > 0) {
                    if (demoValue.type == 'GENDER') {
                        if (demoValue.values.length == 1) {
                            cvo.gender = demoValue.values[0].id;
                        } else {
                            //assuming can only have F and M if more than 1
                            cvo.gender = GenderConst.All.value;
                        }
                    }
                    if (demoValue.type == 'AGE') {
                        cvo.age = this.convertDemoAgeId(demoValue.values[0].id);
                    }
                }
            }
        }));
        */

        //get language, channel, genre, save promise so that in can be reused below for goal
        let allAttributesPromise = api.getCampaignAttributes(this.http, campaignId);
        allFetchPromises.push(allAttributesPromise.then((resp) => {
            if (resp) {
                let attribute, attributes, excludeChannelAttribute, adDurationAttribute, adDurationAttributes;
                if (resp && resp.length) {
                    //use name to figure out which one is language/channel/genre constraint
                    attributes = resp.filter(v => v.name.trim() === CONSTRAINT_LCG_ATTRIBUTES);
                    attribute = attributes.length > 0 && attributes[0];
                    attributes = resp.filter(v => v.name.trim() === CONSTRAINT_CHANNEL_EXCLUSION);
                    excludeChannelAttribute = attributes.length > 0 && attributes[0];
                    adDurationAttributes = resp.filter(v => v.name.trim() === CONSTRAINT_AD_DURATION);
                    adDurationAttribute = adDurationAttributes.length > 0 && adDurationAttributes[0];
                }

                if (attribute) {
                    cvo.constraintId = attribute.constraint_id;
                    let languages = [], channels = [], genres = [];
                    if (attribute.criteria && attribute.criteria.values) {
                        for (let value of attribute.criteria.values) {
                            switch (value.type) {
                                case 'LANGUAGE':
                                    if (value.values && value.values.length > 0) {
                                        for (let v of value.values) {
                                            languages.push(v.id);
                                        }
                                    }
                                    break;
                                case 'NETWORK':
                                    if (value.values && value.values.length > 0) {
                                        for (let v of value.values) {
                                            channels.push(v.id);
                                        }
                                    }
                                    break;
                                case 'GENRE':
                                    if (value.values && value.values.length > 0) {
                                        for (let v of value.values) {
                                            genres.push(v.id);
                                        }
                                    }
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                    cvo.languages = languages;
                    cvo.channels = channels;
                    cvo.genres = genres;
                }

                if (excludeChannelAttribute) {
                    cvo.excludeChannelsConstraintId = excludeChannelAttribute.constraint_id;
                    //no need to the channels in the vo since it is required for rendering
                }

                if (adDurationAttribute) {
                    if (adDurationAttribute.criteria && adDurationAttribute.criteria.values && adDurationAttribute.criteria.values.length > 0) {
                        cvo.adDuration = adDurationAttribute.criteria.values[0].values[0].id;
                    }
                }
            }
        }));

        //get campaign budget
        allFetchPromises.push(api.getCampaignBudget(this.http, campaignId).then((resp) => {
            if (resp != null) {
                cvo.budget = resp.spend;
            }
        }));

        let temporaryGoalTypeId: number;
        allFetchPromises.push(api.getCampaignObjectives(this.http, campaignId).then((resp) => {
            if (resp && resp.length) {
                cvo.goalObjectiveId = resp[0].id;
                temporaryGoalTypeId = resp[0].type_id;
            } else {
                cvo.autoSelect = true;
            }
        }));

        //media plan option
        allFetchPromises.push(this.fetchMediaPlanOption(campaignId).then((resp) => {
            if (resp && resp.type) {
                cvo.mediaPlanOption = resp;
            }
        }));

        //skip creative
        allFetchPromises.push(this.getCampaignSettings(campaignId).then((resp) => {
            if (resp) {
                cvo.skipCreative = resp.allow_launch_without_creatives;
            }
        }));

        return Promise.all(allFetchPromises).then(() => {
            //need to update status since they required data from both campaign data and flight
            let startDate = cvo.startDate ? new Date(cvo.startDate) : null;
            cvo.status = this.convertCampaignStatus(cvo.status, startDate);

            if (temporaryGoalTypeId && temporaryGoalTypeId !== undefined) {
                if (temporaryGoalTypeId === MAXIMIZE_BUY_DEMO_IMPRESSIONS_OBJECTIVE_ID) {
                    cvo.goalType = GoalType.moreImpressionsGRPs.value;
                } else if (temporaryGoalTypeId === MAXIMIZE_BUY_DEMO_REACH_OBJECTIVE_ID) {
                    cvo.goalType = GoalType.moreReach.value;
                }
            }

            //calculate media plan impressions
            if (cvo.mediaPlanOption && cvo.mediaPlanOption.cpm && cvo.budget) {
                this.getMediaPlanOptions(cvo).then((mediaPlanOptions: MediaPlanOptionVO[]) => {
                    let mediaPlanOption: MediaPlanOptionVO = mediaPlanOptions.find((v: MediaPlanOptionVO) => {
                        return v.type === cvo.mediaPlanOption.type;
                    });
                    if (mediaPlanOption) {
                        cvo.mediaPlanOption.impressions = mediaPlanOption.impressions;
                    } else {
                        console.log('Cannot find media option based on type ' + cvo.mediaPlanOption.type);
                        console.log('Using manual calculation instead');
                        cvo.mediaPlanOption.impressions = cvo.budget / cvo.mediaPlanOption.cpm * 1000;
                    }
                }, (e) => {
                    console.log('Error on fetch media options from cvo: ', e);
                    console.log('Using manual calculation instead');
                    cvo.mediaPlanOption.impressions = cvo.budget / cvo.mediaPlanOption.cpm * 1000;
                });
            }

            console.log('fetched cvo', cvo);
            return cvo;
        });
    }

    public submitCampaign(campaignId: number): Promise<any> {
        let input: CampaignStatusUpdateInput = {
            status: 'SENT',
            timestamp: (new Date()).toJSON(),
            updated_by: null,
            note: null
        };
        return api.submitCampaign(this.http, campaignId, input).then();
    }

    public submitMedia(cvo: CampaignVO, creatives: CreativeVO[]): Promise<any> {
        let allSavePromises: Array<Promise<any>> = [];
        let creativesToAssign: CampaignAssociations[] = [];
        if (creatives && creatives.length > 0) {
            creativesToAssign = _.map(creatives, (c: CreativeVO) => {
                return { creative_id: c.creativeId };
            });
        }
        let creativeAssignPromise: Promise<any> = creativeApi.assignCreativesToCampaign(this.http, cvo.id, creativesToAssign);
        allSavePromises.push(creativeAssignPromise.then(() => {
            return this.addDurationConstraints(cvo.id, cvo.creatives, cvo.adDuration);
        }).then());
        allSavePromises.push(this.updateCampaignSettings(cvo.id, cvo.skipCreative));
        return Promise.all(allSavePromises).then();
    }

    public getOrder(orderId: string): Promise<CampaignOrder> {
        return api.getOrder(this.http, orderId);
    }

    public getCampaignStepperProps(campaignVO?: CampaignVO, campaignId?: number, budget?: number): Promise<{ steps: Array<IStepProps>; completedStep: IStepsProps['completedStep'] }> {
        let isBudgetBelowSize: boolean = campaignVO ? campaignVO.budget < Constants.CAMPAIGN_BUDGET_SIZE : budget < Constants.CAMPAIGN_BUDGET_SIZE;
        let mediaPlanStatus: { status: string } = { status: null };
        let v: { steps: Array<IStepProps>; completedStep: IStepsProps['completedStep'] } = {
            steps: [
                {
                    label: CampaingStatusSteps.CampaignReceived
                },
                {
                    label: CampaingStatusSteps.AdsUploaded
                },
                {
                    label: CampaingStatusSteps.MediaPlanCreated
                },
                {
                    label: CampaingStatusSteps.PaymentReceived
                },
                {
                    label: CampaingStatusSteps.AwaitingAdsApproval
                },
                {
                    label: CampaingStatusSteps.CampaignApproved
                }
            ],
            completedStep: 0,
        };
        if (isBudgetBelowSize) {
            // remove media plan step
            v.steps.splice(2, 1);
        }

        // step 1, always completed, since it is pending campaign
        v.completedStep = 1;

        let retPromise: Promise<{ steps: Array<IStepProps>; completedStep: IStepsProps['completedStep'] }> = Promise.resolve(v).then(
            // step 2, check if campaign is associated with creatives
            () => {
                if (campaignVO) {
                    if (!campaignVO.creatives || campaignVO.creatives.length === 0) {
                        v.steps[1].label = CampaingStatusSteps.AdsMissing;
                        v.steps[1].warning = true;
                    }
                    v.completedStep = 2;
                    return v;
                } else {
                    return creativeApi.getCampaignCreatives(this.http, campaignId).then((creatives: CampaignCreativeData[]) => {
                        if (!creatives || creatives.length === 0) {
                            v.steps[1].label = CampaingStatusSteps.AdsMissing;
                            v.steps[1].warning = true;
                        }
                        v.completedStep = 2;
                        return v;
                    });
                }
            }
        ).then(
            () => {
                if (isBudgetBelowSize) {
                    // step 3, check campaign's payment
                    return this.checkCampaignPayment(v, 3, campaignVO, campaignId);
                } else {
                    // step 3, check if campagin already has plan generated
                    return this.checkCampaignHasPlanGenerated(v, 3, isBudgetBelowSize, mediaPlanStatus, campaignVO, campaignId);
                }
            }
        ).then(
            () => {
                if (isBudgetBelowSize) {
                    // step 4, check if campagin already has plan generated still, but not making stepper changes
                    return this.checkCampaignHasPlanGenerated(v, 4, isBudgetBelowSize, mediaPlanStatus, campaignVO, campaignId);
                } else {
                    // step 4, check campaign's payment
                    return this.checkCampaignPayment(v, 4, campaignVO, campaignId);
                }

            }
        ).then(
            // step 5, check if all creatives approved
            () => {
                return creativeApi.getCampaignCreativeStatus(this.http, campaignId || campaignVO.id).then(
                    // step 2, check if campagin contains creative
                    (res: CampaignCreativeStatus) => {
                        let step = isBudgetBelowSize ? 4 : 5;
                        if (res.Result && res.Result.length > 0 && res.Result[0].FlightMediaManage && res.Result[0].FlightMediaManage.length > 0) {
                            let isAllApproved = true, isAnyRejected = false;
                            res.Result[0].FlightMediaManage.forEach((value) => {
                                if (value.ApprovalStatus === CreativeStatus.Rejected) {
                                    isAnyRejected = true;
                                    isAllApproved = false;
                                } else if (value.ApprovalStatus !== CreativeStatus.Approved) {
                                    isAllApproved = false;
                                }
                            });
                            if (isAllApproved) {
                                v.steps[step - 1].label = CampaingStatusSteps.AdsApproved;
                                v.completedStep = step;
                                return v;
                            } else if (isAnyRejected) {
                                v.steps[step - 1].label = CampaingStatusSteps.AdsRejected;
                                v.steps[step - 1].warning = true;
                                v.completedStep = step;
                            }
                        }
                        throw new Error(`No creative status found or there is pending creative, stop at step ${step}`);
                    }
                );
            }
        ).then(
            // step 6, check if media plan is approved
            () => {
                if (mediaPlanStatus.status && mediaPlanStatus.status === MediaPlanStatus.APPROVED.key) {
                    v.completedStep = isBudgetBelowSize ? 5 : 6;
                }
                return v;
            }
        ).catch(
            (err) => {
                return v;
            }
        );

        return retPromise;
    }

    private checkCampaignHasPlanGenerated(v: { steps: Array<IStepProps>; completedStep: IStepsProps['completedStep'] }, step: number, isBudgetBelowSize: boolean, mediaPlanStatus: { status: string }, campaignVO?: CampaignVO, campaignId?: number) {
        if (campaignVO && campaignVO.mediaPlan) {
            let index = step - 1;
            mediaPlanStatus.status = campaignVO.mediaPlan.status;
            if (isBudgetBelowSize) {
                return v;
            }
            if (campaignVO.mediaPlan.status === MediaPlanStatus.APPLIED.key || campaignVO.mediaPlan.status === MediaPlanStatus.APPROVED.key) {
                v.steps[index].label = CampaingStatusSteps.MediaPlanAccepted;
                v.completedStep = step;
                return v;
            } else if (campaignVO.mediaPlan.status === MediaPlanStatus.REVIEW.key) {
                v.steps[index].label = CampaingStatusSteps.MediaPlanReady;
                v.steps[index].warning = true;
                v.completedStep = step;
                return v;
            }
            throw new Error(`No Media Plan found or Media Plan is still processing, stop at step ${step}`);
        } else {
            return api.getCampaignMediaPlan(this.http, campaignId || campaignVO.id).then((res: CampaignMediaPlanData[]) => {
                if (res && res.length > 0) {
                    let mediaPlan = res.find((cmpd) => cmpd.status === MediaPlanStatus.APPLIED.key || cmpd.status === MediaPlanStatus.REVIEW.key || cmpd.status === MediaPlanStatus.APPROVED.key);
                    if (!mediaPlan) {
                        mediaPlan = res[0];
                    }
                    let index = step - 1;
                    mediaPlanStatus.status = mediaPlan.status;
                    if (isBudgetBelowSize) {
                        return v;
                    }
                    if (mediaPlan.status === MediaPlanStatus.APPLIED.key || mediaPlan.status === MediaPlanStatus.APPROVED.key) {
                        v.steps[index].label = CampaingStatusSteps.MediaPlanAccepted;
                        v.completedStep = step;
                        return v;
                    } else if (mediaPlan.status === MediaPlanStatus.REVIEW.key) {
                        v.steps[index].label = CampaingStatusSteps.MediaPlanReady;
                        v.steps[index].warning = true;
                        v.completedStep = step;
                        return v;
                    }
                } else if (isBudgetBelowSize) {
                    return v;
                }
                throw new Error(`No Media Plan found or Media Plan is still processing, stop at step ${step}`);
            });
        }
    }

    private checkCampaignPayment(v: { steps: Array<IStepProps>; completedStep: IStepsProps['completedStep'] }, step: number, campaignVO?: CampaignVO, campaignId?: number) {
        return this.getCampaignOrder(campaignId || campaignVO.id).then((co) => {
            let paidOrder = _.find(co, (order: OrderVO) => order.status === OrderStatus.PAID);
            if (paidOrder) {
                v.completedStep = step;
            } else {
                throw new Error(`Payment is partially paid or not paid, stop at step ${step}`);
            }
            return v;
        });
    }

    public getCampaignMediaPlan(campaignId: number): Promise<Array<MediaPlanVO>> {
        return api.getCampaignMediaPlan(this.http, campaignId).then((resp) => {
            return this.convertCampaignMediaPlanData(resp);
        });
    }

    public getCampaignPricingSummary(campaignId: number, creativeIds?: number[], discountCode?: string, mediaPlanOptionVO?: MediaPlanOptionVO): Promise<PricingSummaryVO> {
        return api.getCampaignPricingSummary(this.http, campaignId, creativeIds, discountCode, mediaPlanOptionVO ? mediaPlanOptionVO.type : undefined).then((resp: CampaignPricingSummary) => {
            let result: PricingSummaryVO = this.convertPricingSummayDataToVO(campaignId, resp);
            return result;
        });
    }

    private convertPricingSummayDataToVO(campaignId: number, resp: CampaignPricingSummary | CampaignOrder): PricingSummaryVO {
        let promotionDiscountValue = 0, discountCodeValue = 0, agencyCommissionValue = 0, tax = 0, creativeTotal = 0, campaignBudget = 0, creativesCost: PricingSummaryVO['creativesCost'];

        if (resp.adjustments && resp.adjustments.length) {
            resp.adjustments.forEach((item) => {
                if (item.adjustment_type === PaymentAdjustmentType.PROMOTION) {
                    promotionDiscountValue = item.value || 0;
                } else if (item.adjustment_type === PaymentAdjustmentType.DISCOUNT_CODE) {
                    discountCodeValue = item.value || 0;
                } else if (item.adjustment_type === PaymentAdjustmentType.AGENCY_COMMISSION) {
                    agencyCommissionValue = item.value || 0;
                } else if (item.adjustment_type === PaymentAdjustmentType.TAX) {
                    tax = item.value || 0;
                }
            });
        }

        if (resp.entities && resp.entities.length) {
            let creatives = [];
            resp.entities.forEach((e) => {
                if (e.entity_type === 'CAMPAIGN') {
                    campaignBudget = e.budget;
                } else {
                    // creatives
                    creatives.push({
                        creativeId: e.entity_id,
                        budget: e.budget
                    });
                    creativeTotal += e.budget;
                }
            });
            if (creativeTotal > 0) {
                creativesCost = {
                    creatives: creatives,
                    total: creativeTotal
                }
            }
        }

        let result: PricingSummaryVO = {
            campaignId: campaignId,
            discountCodeId: resp.discount_code_id,
            discountCode: resp.discount_code,
            entities: resp.entities,
            campaignCost: {
                budget: campaignBudget,
                promotionDiscountValue: promotionDiscountValue,
                discountCodeValue: discountCodeValue,
                agencyCommissionValue: agencyCommissionValue,
                total: Math.max(campaignBudget + promotionDiscountValue + discountCodeValue + agencyCommissionValue, 0)
            },
            creativesCost: creativesCost,
            totalBeforeTax: Math.max(campaignBudget + promotionDiscountValue + discountCodeValue + agencyCommissionValue, 0) + creativeTotal,
            gst: tax,
            grandTotalCost: resp.payment_amount
        };
        return result;
    }

    public getCampaignOrder(campaignId: number): Promise<Array<OrderVO>> {
        return api.getCampaignOrder(this.http, campaignId).then((resp: Array<CampaignOrder>) => {
            let result: Array<OrderVO> = resp.map((orderData: CampaignOrder) => {
                return {
                    orderId: orderData.order_id,
                    sessionId: orderData.session_id,
                    status: orderData.status,
                    ...this.convertPricingSummayDataToVO(campaignId, orderData)
                };
            });
            return result;
        });
    }

    public convertCampaignMediaPlanData(data: Array<CampaignMediaPlanData>): Array<MediaPlanVO> {
        let results: Array<MediaPlanVO> = []
        for (let mp of data) {
            let mpvo = new MediaPlanVO();
            mpvo.id = mp.media_plan_id;
            mpvo.name = mp.media_plan_name;
            mpvo.budget = mp.budget;
            mpvo.totalImpressions = mp.total_impressions;
            mpvo.totalCpm = mp.total_cpm;
            mpvo.demoCpm = mp.demo_cpm;
            mpvo.demoImpressions = mp.demo_impressions;
            mpvo.targetCpm = mp.target_cpm;
            mpvo.targetImpressions = mp.target_impressions;
            mpvo.currency = mp.currency;
            mpvo.status = mp.status;
            mpvo.downloadLink = mp.attachment ? mp.attachment.url : '';
            mpvo.downloadFileName = mp.attachment ? mp.attachment.name : '';
            results.push(mpvo);
        }
        return results;
    }

    public getMediaPlanStatus(campaignId: number, mediaplanId: number): Promise<MediaPlanStatusResponse> {
        return api.getMediaPlanStatus(this.http, campaignId, mediaplanId).then((resp) => {
            return resp;
        });
    }

    public updateMediaPlanStatus(campaignId: number, mediaplanId: number, status: string): Promise<MediaPlanStatusResponse> {
        let input: MediaPlanStatusInput = {
            status: status
        };
        return api.updateMediaPlanStatus(this.http, input, campaignId, mediaplanId).then((resp) => {
            return resp;
        });
    }

    public downloadMediaPlan(campaignId: number, mediaplanId: number): Promise<Blob> {
        return api.downloadMediaPlan(this.http, campaignId, mediaplanId).then((resp: Blob) => {
            return resp;
        });
    }

    public getCampaignSettings(campaignId: number): Promise<CampaignSettingsData> {
        return api.getCampaignSettings(this.http, campaignId).then((resp) => {
            return resp;
        });
    }

    public updateCampaignSettings(campaignId: number, skipCreative: boolean): Promise<CampaignSettingsData> {
        let input: CampaignSettingsData = {
            allow_launch_without_creatives: skipCreative
        };
        return api.updateCampaignSettings(this.http, input, campaignId).then((resp) => {
            return resp;
        });
    }

    public getPacingReportData(campaignId: number): Promise<PacingReportData> {
        return api.getPacingReportData(this.http, campaignId).then((resp) => {
            return resp;
        });
    }

    public downloadPacingReportData(campaignId: number): Promise<Blob> {
        return api.downloadPacingReportData(this.http, campaignId).then((resp: Blob) => {
            return resp;
        });
    }

    public getCampaignsCount(advertiserId: number, brandId: number): Promise<number> {
        let cba = {
            customerId: null,
            advertiserId: advertiserId,
            brandId: brandId
        };
        let input = new CampaignDashboardInput(cba);
        input.limit = 1;

        return api.getCampaignsCount(this.http, input).then((count) => {
            return count;
        });
    }

    public getCampaignList(advertiserId: number, brandId: number, params: any): Promise<ListResponse> {
        let cba = {
            customerId: null,
            advertiserId: advertiserId,
            brandId: brandId
        };
        let input = new CampaignDashboardInput(cba);
        if (params.limit && params.limit > 0) {
            input.limit = params.limit;
        }
        if (params.offset && params.offset > 0) {
            input.offset = params.offset;
        }
        if (params.searchString && params.searchString.length > 0) {
            input.search = params.searchString;
        }

        return api.getCampaignDashboard(this.http, input)
            .then((result) => {
                let results = result.data.map((value) => {
                    return {
                        name: value.campaign_name,
                        id: value.campaign_id
                    };
                });
                let count = result.count;
                console.log(results, count);
                return { results: results, count: count };
            });
    }

    public getCustomersListData(): Promise<ListResponse> {
        let customersData: Array<any> = [],
            customerPromise = this.getCustomers(),
            allAdvPromises: Array<Promise<any>> = [],
            allBrandPromises: Array<Promise<any>> = [];
        return customerPromise.then(customers => {
            customers.forEach(customer => {
                allAdvPromises.push(this.getAdvertiserIds(customer.Id).then(advertisers => {
                    advertisers.forEach(advertiser => {
                        allBrandPromises.push(this.getBrandIds(customer.Id, advertiser.Id).then(brands => {
                            let i = _.findIndex(customersData, { id: advertiser.Id });
                            if (i > -1) {
                                customersData[i].name = customer.Name;
                                customersData[i].customerId = customer.Id;
                                customersData[i].advertiserName = advertiser.Name;
                                customersData[i].id = advertiser.Id;
                                customersData[i].brands = brands.length;
                            } else {
                                customersData.push({
                                    name: customer.Name,
                                    customerId: customer.Id,
                                    advertiserName: advertiser.Name,
                                    id: advertiser.Id,
                                    brands: brands.length
                                });
                            }
                        }));
                        allBrandPromises.push(this.getCampaignsCount(advertiser.Id, null).then((count) => {
                            let i = _.findIndex(customersData, { id: advertiser.Id });
                            if (i > -1) {
                                customersData[i].campaigns = count;
                            } else {
                                customersData.push({
                                    campaigns: count,
                                    id: advertiser.Id
                                });
                            }
                        }));
                    });

                    return Promise.all(allBrandPromises);
                }));
            })
            return Promise.all(allAdvPromises).then(() => {
                return {
                    results: customersData,
                    count: customersData.length
                }
            });
        });
    }

    public getBrandsListData(customerId: number): Promise<ListResponse> {
        let brandsData: Array<any> = [],
            allBrandPromises: Array<Promise<any>> = [],
            allCampaignCountPromise: Array<Promise<any>> = [];
        return this.getAdvertiserIds(customerId).then(advertisers => {
            advertisers.forEach(advertiser => {
                allBrandPromises.push(this.getBrandIds(customerId, advertiser.Id).then(brands => {
                    brands.forEach(brand => {
                        let i = _.findIndex(brandsData, { id: brand.Id });
                        if (i > -1) {
                            brandsData[i].advertiserName = advertiser.Name;
                            brandsData[i].advertiserId = advertiser.Id;
                            brandsData[i].name = brand.Name;
                            brandsData[i].id = brand.Id;
                        } else {
                            brandsData.push({
                                advertiserName: advertiser.Name,
                                advertiserId: advertiser.Id,
                                name: brand.Name,
                                id: brand.Id
                            });
                        }
                        allCampaignCountPromise.push(this.getCampaignsCount(null, brand.Id).then((count) => {
                            let i = _.findIndex(brandsData, { id: brand.Id });
                            if (i > -1) {
                                brandsData[i].campaigns = count;
                            } else {
                                brandsData.push({
                                    campaigns: count,
                                    id: brand.Id
                                });
                            }
                        }));
                    });
                    return Promise.all(allCampaignCountPromise);
                }));
            });
            return Promise.all(allBrandPromises).then(() => {
                return {
                    results: brandsData,
                    count: brandsData.length
                }
            });
        });
    }

    public getPlan(planId: number): Promise<PlanCreationData> {
        return api.getPlan(this.http, planId).then((resp) => {
            return resp;
        })
    }

    public getAdvertiserListData(customerId: number) {
        let advertisersData: Array<any> = [],
            advPromise = this.getAdvertiserIds(customerId),
            allBrandPromises: Array<Promise<any>> = [];

        return advPromise.then((advertisers) => {
            advertisers.forEach(advertiser => {
                allBrandPromises.push(this.getBrandIds(customerId, advertiser.Id).then(brands => {
                    let i = _.findIndex(advertisersData, { id: advertiser.Id });
                    if (i > -1) {
                        advertisersData[i].name = advertiser.Name;
                        advertisersData[i].id = advertiser.Id;
                        advertisersData[i].brands = brands.length;
                    } else {
                        advertisersData.push({
                            name: advertiser.Name,
                            id: advertiser.Id,
                            brands: brands.length
                        });
                    }
                }));
                allBrandPromises.push(this.getCampaignsCount(advertiser.Id, null).then((count) => {
                    let i = _.findIndex(advertisersData, { id: advertiser.Id });
                    if (i > -1) {
                        advertisersData[i].campaigns = count;
                    } else {
                        advertisersData.push({
                            campaigns: count,
                            id: advertiser.Id
                        });
                    }
                }));
            });

            return Promise.all(allBrandPromises).then(() => {
                return {
                    results: advertisersData,
                    count: advertisersData.length
                }
            });;
        })
    }

    public getAllRejectedCreative(campaignId: number): Promise<Array<number>> {
        return creativeApi.getCampaignCreativeStatus(this.http, campaignId).then(
            (res: CampaignCreativeStatus) => {
                let rejectedCreativeIds: Array<number> = [];
                if (res.Result && res.Result.length > 0 && res.Result[0].FlightMediaManage && res.Result[0].FlightMediaManage.length > 0) {
                    res.Result[0].FlightMediaManage.forEach((value) => {
                        if (value.ApprovalStatus === CreativeStatus.Rejected) {
                            rejectedCreativeIds.push(value.MediaId);
                        }
                    });
                }
                return rejectedCreativeIds;
            });
    }

}
